import getLocalString from "constants/Localization";
import { CustomGetProposalDocument, Proposal, useHoldProposalMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useHoldProposal({ id }: { id: Proposal["id"] }) {
  const [mutation, { loading, error, data }] = useHoldProposalMutation();

  const [holdProposal, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "holdProposal",
    },
    {
      successMessage: getLocalString("proposals.hold-proposal-success"),
      failureMessage: getLocalString("proposals.hold-proposal-failure"),
    }
  );

  return [holdProposal, context] as const;
}
